import { render, staticRenderFns } from "./start.vue?vue&type=template&id=bc900972&scoped=true&%3Akey=new%20Date().getTime()%20%2B%20loggedIn&"
import script from "./start.vue?vue&type=script&lang=js&"
export * from "./start.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc900972",
  null
  
)

export default component.exports